import { render } from "./ErrorList.vue?vue&type=template&id=398cbfd2&scoped=true"
import script from "./ErrorList.vue?vue&type=script&lang=js"
export * from "./ErrorList.vue?vue&type=script&lang=js"

import "./ErrorList.vue?vue&type=style&index=0&id=398cbfd2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-398cbfd2"

export default script